import { render, staticRenderFns } from "./PosTrend_Index.vue?vue&type=template&id=6244f75a&scoped=true"
import script from "./PosTrend_Index.vue?vue&type=script&lang=js"
export * from "./PosTrend_Index.vue?vue&type=script&lang=js"
import style0 from "./PosTrend_Index.vue?vue&type=style&index=0&id=6244f75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244f75a",
  null
  
)

export default component.exports